import { render, staticRenderFns } from "./DamageTypes.vue?vue&type=template&id=eb119e9a"
import script from "./DamageTypes.vue?vue&type=script&lang=js"
export * from "./DamageTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports